module.exports = __webpack_public_path__ + "static/media/node-express.6bb1fcbc.svg";